<template>
  <span>
    <a v-if="customerId" :href="customerUrl(customerId)" target="_blank">{{ customerId }}</a>
    <span v-if="customer">
      <a v-if="customer.id" :href="customerUrl(customer.id)" target="_blank">{{ customer.id }}</a>
      <span v-if="customer.id && !customer.deleted"> (active)</span>
      <span v-if="customer.id && customer.deleted"> (deleted)</span>
      <span v-if="customer && !customer.id">not set</span>
    </span>
  </span>
</template>
<script type="ts">
import Vue from 'vue';
import Customer from '@/datatypes/enterprise/billing-customer';

export default Vue.extend({
  name: 'customer-text',
  props: {
    customer: {
      type: Customer,
      default: undefined,
    },
    customerId: {
      type: String,
      default: '',
    },
  },
  methods: {
    customerUrl(customerId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].customer(customerId);
    },
  },
});
</script>
